import { format, isToday, isThisYear, parseISO } from "date-fns";
import { t } from "i18next";
import { UserDiscussionNotification } from "../../app.types";
import { UserNotificationType } from "../../app.constants";

export const formatNotificationDate = (dateString: string): string => {
  try {
    const date = parseISO(dateString);
    if (isToday(date)) {
      return format(date, "h:mm a");
    } else if (isThisYear(date)) {
      return format(date, "MMM d");
    } else {
      return format(date, "MMM d, yyyy");
    }
  } catch (error) {
    return dateString;
  }
};

export const getDiscussionTitle = (notification: UserDiscussionNotification) => {
  let prefix = "";
  if (notification.notificationType === UserNotificationType.DISCUSSION_COMMENT_MENTION) {
    prefix = t("Mentioned you");
  } else if (notification.notificationType === UserNotificationType.DISCUSSION_ACTIVITY) {
    const discussionCommentCount = notification.discussionCommentCount;
    if (discussionCommentCount === 1) {
      prefix = t("Left a comment");
    } else {
      prefix = `${discussionCommentCount} ${t("comments")}`;
    }
  }
  return `${prefix} — ${notification.requirementName}`;
};

export const getUserTitle = (notification: UserDiscussionNotification) => {
  const discussionCommentByUsers = notification.discussionCommentByUsers;
  if (discussionCommentByUsers.length === 1) {
    return discussionCommentByUsers[0];
  } else if (discussionCommentByUsers.length === 2) {
    return `${discussionCommentByUsers[0]} and ${discussionCommentByUsers[1]}`;
  } else {
    const lastUser = discussionCommentByUsers[discussionCommentByUsers.length - 1];
    const otherUsers = discussionCommentByUsers.slice(0, -1).join(", ");
    return `${otherUsers} and ${lastUser}`;
  }
};

export const unreadCountToString = (unreadCount: number): string => {
  if (unreadCount <= 0) {
    return "0";
  }
  if (unreadCount > 99) {
    return "99+";
  }
  return String(unreadCount);
};
